// Jest Snapshot v1, https://goo.gl/fbAQLP

exports[`ProjectReport model belongsTo relations 1`] = `
Array [
  "ProjectReportCategory",
]
`;
